export default __webpack_public_path__ + "static/media/Sherry.85f34581.JPG";